import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Sedancabbookinginpune() {



const cardData = {
  keyword: " Sedan Cabs Booking in Pune  ",

headingDescription: "Velocity Cab provides easy and reliable sedan cabs booking in Pune, offering comfortable, affordable, and punctual travel for city rides, airport transfers, business trips, outstation journeys, and family outings. Our fleet of well‑maintained air‑conditioned sedans includes popular models that balance comfort, fuel efficiency, and ample luggage space, making them ideal for solo travelers, couples, and small families. We offer flexible booking options with transparent pricing, no hidden charges, professional drivers, and 24/7 customer support. With simple online booking and prompt service, Velocity Cab is the trusted choice for sedan cab bookings in Pune.",

topPlaces: [
  {
    title: "Lonavala",
    description: "Lonavala is one of the most popular hill stations near Pune, known for its lush green valleys, waterfalls, and scenic viewpoints. Travelers booking a sedan cab can enjoy a comfortable drive to explore attractions like Tiger Point, Bhushi Dam, Rajmachi Point, and Karla Caves. The pleasant weather and beautiful landscapes make it an ideal destination for weekend getaways and nature lovers."
  },
  {
    title: "Khandala",
    description: "Khandala is a picturesque hill station located close to Pune, famous for its misty hills, waterfalls, and panoramic viewpoints. Visitors using a sedan cab can enjoy a relaxing journey while exploring Duke’s Nose, Sunset Point, and Rajmachi Fort. The serene surroundings make it perfect for sightseeing, photography, and peaceful retreats."
  },
  {
    title: "Mahabaleshwar",
    description: "Mahabaleshwar is a renowned hill station near Pune celebrated for its strawberry farms, breathtaking viewpoints, and pleasant climate. Travelers booking a sedan cab can visit Venna Lake, Arthur’s Seat, Elephant’s Head Point, and Mapro Garden while enjoying scenic mountain roads. It is an excellent destination for families, couples, and nature enthusiasts."
  },
  {
    title: "Panchgani",
    description: "Panchgani is a charming hill station known for its rolling hills, Table Land, and colonial-era charm. Sedan cab travelers can explore scenic viewpoints, strawberry farms, and lush valleys while enjoying a comfortable outstation journey. The peaceful atmosphere makes it ideal for relaxation, sightseeing, and photography."
  },
  {
    title: "Lavasa",
    description: "Lavasa is a beautifully planned hill city near Pune offering colorful architecture, lakeside views, and adventure activities. Travelers using a sedan cab can enjoy a scenic drive through the Western Ghats, stroll along the waterfront promenade, and indulge in boating, cycling, and nature walks. It is a perfect destination for a refreshing day trip."
  },
  {
    title: "Matheran",
    description: "Matheran is India's smallest hill station and is famous for its vehicle-free environment, dense forests, and stunning viewpoints. Sedan cab travelers can drive to Dasturi Point before exploring the hill station on foot or horseback. Popular attractions include Panorama Point, Echo Point, and Charlotte Lake."
  },
  {
    title: "Alibaug",
    description: "Alibaug is a popular coastal destination near Pune known for its sandy beaches, sea forts, and relaxed atmosphere. Travelers booking a sedan cab can visit Alibaug Beach, Kolaba Fort, Nagaon Beach, and Varsoli Beach while enjoying a comfortable road trip. It is ideal for beach lovers, families, and weekend vacations."
  },
  {
    title: "Bhimashankar",
    description: "Bhimashankar is a revered pilgrimage destination and wildlife sanctuary nestled in the Sahyadri hills. Travelers using a sedan cab can visit the famous Jyotirlinga temple, explore scenic trekking trails, and experience the rich biodiversity of the surrounding forest. The destination is perfect for spiritual seekers and nature lovers."
  },
  {
    title: "Kaas Plateau",
    description: "Kaas Plateau, also known as the Valley of Flowers of Maharashtra, is a UNESCO World Heritage Site famous for its seasonal bloom of colorful wildflowers. Sedan cab travelers can enjoy a scenic drive from Pune to witness the breathtaking floral landscape, making it an unforgettable destination for nature enthusiasts and photographers."
  },
  {
    title: "Raigad Fort",
    description: "Raigad Fort is one of Maharashtra’s most significant historical landmarks and the former capital of Chhatrapati Shivaji Maharaj. Travelers booking a sedan cab can enjoy a scenic drive to the fort, explore its grand gateways, royal palace ruins, and panoramic hilltop views. The destination offers a perfect blend of history, adventure, and breathtaking scenery."
  }
],



services: [
{
name: "Sedan Cabs in Pune",
description: "Sedan cabs in Pune offer one of the most preferred travel options for individuals and small families looking for comfort, affordability, and smooth rides. Vehicles like Swift Dzire and Toyota Etios provide excellent mileage and spacious seating, making them ideal for both city and outstation travel. These cabs are widely used for airport transfers, office commute, and weekend trips. Professional drivers ensure safe driving and timely pickups across Pune including Hinjewadi, Kharadi, Wakad, and Viman Nagar. Clean interiors, air-conditioned rides, and easy booking options make sedan cabs a reliable choice. Whether it’s a short trip or a long-distance journey, sedan cabs provide the perfect balance of comfort and cost."
},
{
name: "Best Cab Service in Pune",
description: "Best cab service in Pune provides reliable, safe, and affordable transportation for local and outstation travel. Customers can choose from a wide range of vehicles including sedan, SUV, and premium cars based on their requirements. Professional drivers, timely service, and well-maintained vehicles ensure a smooth travel experience. This service is ideal for airport transfers, corporate travel, and family trips."
},
{
name: "Sedan Taxi Near Me in Pune",
description: "Sedan taxi near me in Pune offers quick and convenient booking options for passengers looking for nearby cabs. With fast pickup and comfortable rides, this service is ideal for daily travel and urgent trips."
},
{
name: "Sedan Cab Service Near Me in Pune",
description: "Sedan cab service near me in Pune provides easy access to reliable transportation with flexible pickup and drop options across the city."
},
{
name: "Sedan Cab Service for Outstations",
description: "Sedan cab service for outstations offers comfortable long-distance travel from Pune to destinations like Mumbai, Nashik, Shirdi, Goa, and Lonavala. Budget-friendly pricing and smooth rides make it ideal for extended journeys."
},
{
name: "Toyota Etios Taxi in Pune",
description: "Toyota Etios taxi in Pune provides comfortable and fuel-efficient travel for city rides and outstation trips. It is a popular sedan choice for budget-friendly travel."
},
{
name: "Toyota Etios Cab in Pune",
description: "Toyota Etios cab in Pune offers reliable transportation with spacious seating and smooth performance, making it ideal for daily travel."
},
{
name: "Taxi & Sedan Services Booking",
description: "Taxi and sedan services booking in Pune allows customers to reserve cabs easily through online platforms with instant confirmation and transparent pricing."
},
{
name: "Sedan Taxi Service for Outstations",
description: "Sedan taxi service for outstations ensures smooth and affordable travel for long-distance journeys with experienced drivers and comfortable vehicles."
},
{
name: "Pune to Nashik Sedan Cab Service",
description: "Pune to Nashik sedan cab service provides comfortable intercity travel with affordable pricing and smooth highway connectivity."
},
{
name: "Pune to Goa Cab Service",
description: "Pune to Goa cab service offers long-distance travel with comfortable sedan options ideal for couples and small families."
},
{
name: "Pune to Mumbai Cab Services",
description: "Pune to Mumbai cab services provide reliable travel with flexible pickup options and comfortable sedan vehicles."
},
{
name: "Pune to Lonavala Sedan Cab",
description: "Pune to Lonavala sedan cab offers quick and comfortable travel for weekend getaways with affordable pricing."
},
{
name: "Outstation Sedan Cab Service",
description: "Outstation sedan cab service provides dependable long-distance travel with budget-friendly options and professional drivers."
},
{
name: "Sedan Cabs for Corporate Outstation",
description: "Sedan cabs for corporate outstation travel offer professional and comfortable transportation for business trips and employee travel."
},
{
name: "Pune to Shirdi Sedan Cabs",
description: "Pune to Shirdi sedan cabs provide convenient and comfortable travel for pilgrimage trips with reliable service."
},
{
name: "Pune to Aurangabad Sedan Taxi",
description: "Pune to Aurangabad sedan taxi service offers smooth and affordable intercity travel with comfortable vehicles."
},
{
name: "Sedan Cab Booking in Pune",
description: "Sedan cab booking in Pune allows quick and easy reservations with instant confirmation and flexible scheduling."
},
{
name: "Sedan Cab in Pune",
description: "Sedan cab in Pune provides dependable transportation for city and outstation travel with comfortable vehicles."
},
{
name: "Sedan Taxi Service Pune",
description: "Sedan taxi service Pune ensures reliable travel with professional drivers and well-maintained vehicles."
},
{
name: "Sedan Cab Hire Pune",
description: "Sedan cab hire Pune offers flexible rental options for local and outstation journeys with budget-friendly pricing."
},
{
name: "Book Sedan Cab Pune",
description: "Book sedan cab Pune easily with online booking, instant confirmation, and transparent pricing for hassle-free travel."
},
{
name: "Cheap Sedan Cab Pune",
description: "Cheap sedan cab Pune provides affordable travel options without compromising on comfort and safety."
},
{
name: "Sedan Taxi Booking Pune",
description: "Sedan taxi booking Pune allows customers to reserve cabs quickly with flexible pickup and drop options."
},
{
name: "AC Sedan Cab Pune",
description: "AC sedan cab Pune offers comfortable air-conditioned travel for city and outstation journeys ensuring a pleasant experience."
},
{
name: "Pune Sedan Taxi Service",
description: "Pune sedan taxi service provides reliable transportation with experienced drivers and comfortable vehicles."
},
{
name: "Sedan Cab for Outstation Pune",
description: "Sedan cab for outstation Pune offers affordable and comfortable travel options for long-distance journeys with professional drivers."
}
],

tableData: [
["Sedan Cabs in Pune","Best Cab Service in Pune"],
["Sedan Taxi Near Me in Pune","Sedan Cab Service Near Me in Pune"],
["Sedan Cab Service for Outstations","Toyota Etios Taxi in Pune"],
["Toyota Etios Cab in Pune","Taxi & Sedan Services Booking"],
["Sedan Taxi Service for Outstations","Pune to Nashik Sedan Cab Service"],
["Pune to Goa Cab Service","Pune to Mumbai Cab Services"],
["Pune to Lonavala Sedan Cab","Outstation Sedan Cab Service"],
["Sedan Cabs for Corporate Outstation","Pune to Shirdi Sedan Cabs"],
["Pune to Aurangabad Sedan Taxi","Sedan Cab Booking in Pune"],
["Sedan Cab in Pune","Sedan Taxi Service Pune"],
["Sedan Cab Hire Pune","Book Sedan Cab Pune"],
["Cheap Sedan Cab Pune","Sedan Taxi Booking Pune"],
["AC Sedan Cab Pune","Pune Sedan Taxi Service"],
["Sedan Cab for Outstation Pune","Sedan Cabs in Pune"]
],



whychoose: [
  {
    WhyChooseheading: "Affordable Sedan Cab Booking",
    WhyChoosedescription: "Velocity Cabs offers budget-friendly sedan cab booking in Pune, perfect for daily travel, airport transfers, and outstation trips with comfortable and economical rides."
  },
  {
    WhyChooseheading: "Experienced Drivers",
    WhyChoosedescription: "Our drivers are well experienced in Pune city routes and highways, ensuring safe driving, smooth journeys, and timely pickups and drop-offs for every customer."
  },
  {
    WhyChooseheading: "Transparent Cab Pricing",
    WhyChoosedescription: "Velocity Cabs provides transparent and competitive pricing for sedan cab booking in Pune. Customers receive complete fare details including per km charges, toll charges, and driver allowance."
  },
  {
    WhyChooseheading: "24/7 Cab Booking Availability",
    WhyChoosedescription: "Our sedan cab service in Pune operates 24/7. Whether you need early morning airport drop or late-night travel, Velocity Cabs ensures reliable service anytime."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All sedan cars are fully air-conditioned, well maintained, and regularly cleaned to provide a comfortable and hassle-free travel experience."
  },
  {
    WhyChooseheading: "Flexible Booking Options",
    WhyChoosedescription: "Velocity Cabs offers flexible booking options including local city travel (8 hours/80 km), outstation trips, one-way rides, round-trip bookings, and customized packages."
  },
  {
    WhyChooseheading: "Ideal for Daily & Business Travel",
    WhyChoosedescription: "Sedan cabs like Swift Dzire and Etios are perfect for solo travelers, couples, and corporate travel with comfortable seating for 4 passengers and luggage space."
  },
  {
    WhyChooseheading: "Trusted Cab Service in Pune",
    WhyChoosedescription: "Velocity Cabs is trusted by many customers for sedan cab booking in Pune due to professional drivers, clean vehicles, and reliable service quality."
  }
]
};

const faqData = [
  { question: "Do you provide sedan cab booking in Pune?", answer: "Yes, Velocity Cabs provides reliable sedan cab booking services in Pune for local and outstation travel." },
  { question: "Which sedan cars are available?", answer: "We offer sedan cars like Swift Dzire, Toyota Etios, and similar models for comfortable travel." },
  { question: "What is the price of sedan cab in Pune?", answer: "Sedan cab pricing usually starts from ₹10 to ₹14 per km or ₹1800 to ₹3000 per day depending on the package." },
  { question: "Is sedan cab available for airport transfers?", answer: "Yes, we provide airport pickup and drop services in Pune using sedan cabs." },
  { question: "Can I book sedan cab for outstation trips?", answer: "Yes, sedan cabs are available for outstation travel from Pune to destinations like Mumbai, Shirdi, Goa, and Mahabaleshwar." },
  { question: "Is cab service available 24 hours?", answer: "Yes, our sedan cab booking service in Pune operates 24/7." },
  { question: "Are vehicles air-conditioned?", answer: "Yes, all sedan vehicles are fully air-conditioned and well maintained." },
  { question: "Can I book sedan cab online?", answer: "Yes, customers can easily book sedan cabs in Pune online or through phone booking." },
  { question: "Is driver included in the booking?", answer: "Yes, all bookings include professional drivers for safe and comfortable travel." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Amit Joshi",
    feedback:
      "Sedan cab booking in Pune with Velocity Cab was a smooth experience. The vehicle was clean, comfortable, and perfect for a hassle-free city ride.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Priya Nair",
    feedback:
      "I booked a sedan cab in Pune from Velocity Cab and the service was excellent. The ride was punctual, comfortable, and the driver was very professional.",
    rating: 5
  }
];





























const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cabs", link: "Pune-to-Mumbai-Airport-Cabs" },
{ place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cabs", link: "Pune-to-Mumbai-International-Airport-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
{ place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
{ place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
{ place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
{ place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
{ place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
{ place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
{ place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
{ place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
{ place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
{ place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];










const puneSedanJSON = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Sedan Cabs Booking in Pune | Velocity Cabs",
  "description": "Book sedan cabs in Pune with Velocity Cabs for local travel, outstation trips, corporate events, and airport transfers. Toyota Etios and other sedan taxis available for Pune to Nashik, Goa, Mumbai, Lonavala, Shirdi, and Aurangabad.",
  "provider": {
    "@type": "Organization",
    "name": "Velocity Cabs",
    "url": "https://www.velocitycabs.com/"
  },
  "areaServed": {
    "@type": "Place",
    "name": "Pune, Maharashtra, India"
  },
  "serviceType": [
    "Sedan Cab Booking Pune",
    "Outstation Sedan Cab",
    "Pune to Nashik Sedan Cab",
    "Pune to Goa Sedan Cab",
    "Pune to Mumbai Sedan Cab",
    "Pune to Lonavala Sedan Cab",
    "Pune to Shirdi Sedan Cab",
    "Pune to Aurangabad Sedan Cab",
    "Corporate Sedan Cab Pune",
    "Toyota Etios Cab Pune",
    "Sedan Taxi Service Pune"
  ],
  "offers": {
    "@type": "Offer",
    "url": "https://www.velocitycabs.com/",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock"
  }
};







  return (
    <div>
      
<Helmet>
  <title>Sedan Cabs Booking in Pune | Velocity Cabs +91 9136271336</title>
  <meta
    name="description"
    content="Book sedan cabs in Pune with Velocity Cabs. Available for local travel, outstation trips, corporate events, and airport transfers. Toyota Etios and other sedans ready for Pune to Nashik, Goa, Mumbai, Lonavala, Shirdi, and Aurangabad."
  />
  <script type="application/ld+json">
    {JSON.stringify(puneSedanJSON)}
  </script>
</Helmet>


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/73.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Velocity Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚗
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Velocity Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Velocity Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919136271336" className="pc-call">+91 9136271336</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919136271336"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919136271336" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@velocitycabs.com" className="pc-email">
        booking@velocitycabs.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Velocity Cab</strong><br />
        Prakash Residency, Sec 10E, Plot 40 Roadpali, Kalamboli 410218 Navi Mumbai, Maharashtra
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Sedancabbookinginpune;